/** Reporting endpoints (`/reports`, management only). */
import { useQuery } from "@tanstack/react-query";
import { getData } from "../lib/apiClient";
import { queryKeys } from "./queryKeys";
import { DailySummary, ProductionReport, SalesReport } from "../types/models";

export interface DateRangeParams {
  dateFrom?: string;
  dateTo?: string;
}

export interface ProductionReportParams extends DateRangeParams {
  groupBy?: "machine" | "shift";
}

export const reportsApi = {
  sales: (params?: DateRangeParams) =>
    getData<SalesReport>("/reports/sales", params),
  production: (params?: ProductionReportParams) =>
    getData<ProductionReport>("/reports/production", params),
  daily: (params?: { date?: string }) =>
    getData<DailySummary>("/reports/daily", params),
};

// ── Hooks ────────────────────────────────────────────────────────────

export const useSalesReport = (params?: DateRangeParams, enabled = true) =>
  useQuery({
    queryKey: queryKeys.reports.sales(params),
    queryFn: () => reportsApi.sales(params),
    enabled,
  });

export const useProductionReport = (
  params?: ProductionReportParams,
  enabled = true,
) =>
  useQuery({
    queryKey: queryKeys.reports.production(params),
    queryFn: () => reportsApi.production(params),
    enabled,
  });

export const useDailySummary = (params?: { date?: string }, enabled = true) =>
  useQuery({
    queryKey: queryKeys.reports.daily(params),
    queryFn: () => reportsApi.daily(params),
    enabled,
  });
